

<template>
  <div class="relative w-full min-h-screen">
    <!-- Full-page Background -->
    <!-- <img
      src="../assets/img/new_bg.png"
      alt="Background"
      class="fixed inset-0 object-cover w-full h-full z-0 brightness-75"
    /> -->
    <img
      src="../assets/img/ab.png"
      alt="Background"
      class="fixed inset-0 object-cover w-full h-full z-0 brightness-75"
    />
    <!-- <div
      class="absolute inset-0 z-0 bg-green1 opacity-50 backdrop-blur-m"
    ></div> -->

    <!-- Page Content -->
    <div class="relative z-10">
      <!-- Hero Section -->
      <section
        class="min-h-screen flex flex-col md:flex-row items-center relative overflow-hidden px-6 md:px-10"
      >
        <!-- Right Content (Globe + Logo) -->
        <div
          class="order-1 md:order-2 flex justify-center items-center w-full md:w-1/2 relative lg:ml-28 mb-[48px] md:mb-0 lg:mb-[48px] mt-20 md:mt-0 lg:mt-0"
        >
          <div class="relative flex items-center justify-center w-full">
            <!-- Globe -->
            <img
              src="../assets/img/dnsc_logo.png"
              alt="DNSC Globe"
              class="absolute inset-0 m-auto w-[200px] sm:w-[300px] md:w-[400px] lg:w-[600px] pgs-globe animate-spinSlow opacity-55"
            />

            <!-- White Logo -->
            <img
              src="../assets/img/dnsc-logo-white.png"
              alt="DNSC Logo"
              class="relative z-30 w-[120px] md:w-[400px] lg:w-[400px] pgs-logo"
            />
          </div>
        </div>

        <!-- Left Content -->
        <div
          class="order-2 md:order-1 flex flex-col justify-center items-center md:items-start w-full md:w-1/2 text-center md:text-left mb-12 md:mb-0 lg:mb-24 lg:ml-20 mt-20 md:mt-0 lg:mt-0"
        >
          <!-- Title -->
          <div
            class="text-4xl sm:text-5xl md:text-7xl lg:text-8xl text-white font-extrabold pgs-title"
          >
            <div class="pgs-title-default">
              <h1>DAVAO</h1>
              <h1>DEL NORTE</h1>
              <h1>STATE</h1>
              <h1>COLLEGE</h1>
            </div>
            <h1 class="hidden pgs-title-hidden">
              DAVAO DEL NORTE STATE COLLEGE
            </h1>
          </div>
          <div
            class="text-white font-semibold text-xl md:text-3xl tracking-wide font-poppins mt-2 text-left"
          >
            Information Systems Gateway
          </div>

          <!-- Login Button -->
          <div
            class="flex justify-center md:justify-start mt-5 md:mt-10 w-full"
          >
            <router-link
              to="/login"
              class="w-fit bg-white px-5 sm:px-6 md:px-5 lg:px-9 py-2.5 text-sm md:text-xl text-green1 rounded-3xl font-medium cursor-pointer hover:bg-green1 hover:text-white hover:shadow-md transition ease-in duration-150 pgs-btn"
            >
              LOGIN
            </router-link>
          </div>
        </div>

        <!-- Scroll Button + Subtitle -->
        <div class="absolute bottom-16 w-full flex flex-col items-center z-50">
          <!-- Subtitle -->
          <div
            class="text-white font-semibold text-xl md:text-4xl tracking-wide mb-[70px] text-center"
          >
            <p class="mt-2 md:mt-0 lg:mt-0 pgs-desc">
              <span class="italic font-light text-sm lg:text-[22px]">A</span>
              <span class="text-md lg:text-2xl font-bold">
                Unified Digital Ecosystem
              </span>
              <span class="italic font-light text-sm lg:text-[22px]">
                where your seamless and secure access is just a click away.
              </span>
            </p>
          </div>

          <!-- Scroll Button -->
          <div
            class="cursor-pointer animate-bounce group absolute top-[115px]"
            @click="scrollToCards"
          >
            <div
              class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
            >
              <!-- Arrow Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-7 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <!-- Hover Text -->
              <span
                class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                Get Started
              </span>
            </div>
          </div>
        </div>
      </section>
      <!-- Cards Section Carousel -->
      <section
        ref="cardsSection"
        class="cards-section w-full bg-transparent px-4 md:px-8 flex flex-col justify-center items-center min-h-screen"
      >
        <div class="w-full max-w-6xl mx-auto py-10 relative flex items-center">
          <!-- Prev Button (Left Side) -->
          <button
            @click="prevCards"
            :disabled="carouselIndex === 0"
            :class="[
              'hidden md:block absolute left-0 md:left-[-40px] lg:left-[-120px] px-4 py-2 text-white rounded-full transition-all z-20 group',
              carouselIndex === 0
                ? 'opacity-50 cursor-not-allowed'
                : 'animate-bounce',
            ]"
          >
            <div
              class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
            >
              <!-- Left Arrow Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-7 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              <span
                class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                Previous
              </span>
            </div>
          </button>

          <!-- Carousel Cards -->
          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full mx-auto"
          >
            <a
              v-for="(feature, index) in paginatedFeatures"
              :key="carouselIndex * cardsPerPage + index"
              :href="feature.link"
              target="_blank"
              rel="noopener noreferrer"
              class="feature-card cursor-pointer transform transition-all duration-700 ease-[cubic-bezier(0.25,0.1,0.25,1)] bg-white/10 backdrop-blur-lg rounded-[30px] shadow-lg p-4 flex flex-col items-center text-center hover:shadow-2xl hover:scale-105 min-h-[320px]"
              :data-index="carouselIndex * cardsPerPage + index"
              :class="
                feature.visible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 -translate-y-12'
              "
              :style="{ transitionDelay: `${index * 80}ms` }"
            >
              <div class="w-full flex justify-center relative">
                <!-- Skeleton Loader (same size as image) -->
                <div
                  v-if="!feature.imgLoaded"
                  class="rounded-2xl bg-white/20 animate-pulse w-full"
                  style="aspect-ratio: auto"
                >
                  <!-- optional shimmer circle inside -->
                  <div class="w-12 h-12 rounded-full bg-white/30 m-auto"></div>
                </div>

                <!-- Actual Image -->
                <img
                  :src="feature.img"
                  alt="System Logo"
                  class="w-full object-contain rounded-2xl transition-opacity duration-500"
                  @load="feature.imgLoaded = true"
                  @error="feature.imgLoaded = true"
                />
              </div>

              <p
                class="text-white font-light text-sm md:text-sm text-justify mt-4 px-2"
              >
                {{ feature.description }}
              </p>
            </a>
          </div>

          <!-- Next Button (Right Side) -->
          <button
            @click="nextCards"
            :disabled="(carouselIndex + 1) * cardsPerPage >= features.length"
            :class="[
              'hidden md:block absolute right-0 md:right-[-40px] lg:right-[-120px] px-4 py-2 text-white rounded-full transition-all z-20 group',
              (carouselIndex + 1) * cardsPerPage >= features.length
                ? 'opacity-50 cursor-not-allowed'
                : 'animate-bounce',
            ]"
          >
            <div
              class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
            >
              <!-- Right Arrow Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-7 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
              <span
                class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                Next
              </span>
            </div>
          </button>
        </div>
        <!-- Scroll to Videos Button -->
        <div
          class="cursor-pointer animate-bounce group w-full flex justify-center"
          @click="scrollToDashboard"
        >
          <div
            class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
          >
            <!-- Down Arrow Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>

            <!-- Hover Text -->
            <span
              class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            >
              Go to Dashboard
            </span>
          </div>
        </div>
      </section>
      <!-- DNSC Dashboard  -->

      <section
        ref="dashboardSection"
        class="w-full bg-transparent px-4 md:px-8 flex flex-col justify-center items-center min-h-screen"
      >
        <div
          class="cursor-pointer animate-bounce group w-full flex justify-center mt-8 z-50"
          @click="scrollToCards"
        >
          <div
            class="group w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
          >
            <!-- Up Arrow Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 15l7-7 7 7"
              />
            </svg>

            <!-- Hover Text ABOVE -->
            <span
              class="absolute bottom-16 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            >
              Back to Systems Cards
            </span>
          </div>
        </div>
        <div
          class="w-[68vw] h-[80vh] ease-[cubic-bezier(0.25,0.1,0.25,1)] bg-white/10 backdrop-blur-lg p-3 rounded-2xl"
        >
         
 <iframe
            title="DNSCDashboard"
            class="w-full h-full border-0 rounded-xl"
            src="https://app.powerbi.com/view?r=eyJrIjoiYTFhODJlY2UtNTliOC00NTFhLWJmZGUtZDhmNmY2YTY4NmEwIiwidCI6ImEwYzRkZWM2LTNjMGEtNDExMy1hN2NmLWY5MzliYTEwODEyYiIsImMiOjEwfQ%3D%3D"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
          
        </div>
        <div class="cursor-pointer animate-bounce group flex justify-center">
          <div
            class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
            @click="scrollToTestimonies"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-7 w-7 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>

            <!-- Tooltip BELOW -->
            <span
              class="absolute top-16 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            >
              Read Testimonies
            </span>
          </div>
        </div>
      </section>

      <!-- Feedback Section -->
      <section
        ref="testimoniesSection"
        class="w-full bg-transparent px-4 md:px-8 flex flex-col justify-center items-center min-h-screen relative overflow-hidden"
      >
        <!-- Container for arrows and carousel -->
        <div class="relative w-full flex justify-center items-center">
          <!-- Up Arrow (Scroll to Cards) -->
          <div
            class="cursor-pointer animate-bounce group absolute top-7 z-50"
            @click="scrollToDashboard"
          >
            <div
              class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
            >
              <!-- Up Arrow Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-7 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M5 15l7-7 7 7"
                />
              </svg>

              <!-- Hover Text -->
              <span
                class="absolute top-16 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                Scroll Back to Dashboard
              </span>
            </div>
          </div>

          <!-- Feedback Carousel -->
          <div class="w-full flex justify-center overflow-hidden">
            <FeedbackCarousel />
          </div>

          <!-- Down Arrow (Scroll to Videos) -->
          <div
            class="cursor-pointer animate-bounce group absolute bottom-4 md:bottom-32 lg:bottom-4 z-40"
            @click="scrollToVideos"
          >
            <div
              class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
            >
              <!-- Down Arrow Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-7 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <!-- Hover Text -->
              <span
                class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                Watch Videos
              </span>
            </div>
          </div>
        </div>
      </section>

<!-- Video Section -->
<section
  ref="videoSection"
  class="relative w-full bg-transparent px-4 md:px-8 flex flex-col justify-center items-center min-h-screen"
>
  <!-- Back to Testimonies Button -->
  <div
    class="cursor-pointer animate-bounce group w-full flex justify-center mt-8 mb-8"
    @click="scrollToTestimonies"
  >
    <div
      class="w-14 h-14 flex items-center justify-center rounded-full
             bg-white/20 backdrop-blur-md border border-white/40
             shadow-md hover:bg-green1 transition-all duration-300 relative"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 15l7-7 7 7"
        />
      </svg>

      <span
        class="absolute top-16 left-1/2 -translate-x-1/2
               whitespace-nowrap text-white text-md font-light
               opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        Back to Testimonies
      </span>
    </div>
  </div>

  <!-- Video Tutorials -->
  <VideoSection
    :videos="videos"
    :fullscreen="fullscreen"
    :videoStatus="videoStatus"
    @updateVideoStatus="updateVideoStatus"
    @updateFullscreen="updateFullscreen"
  />

  <!-- Go to Systems Manual -->
  <div
    class="cursor-pointer animate-bounce group flex justify-center mt-10 mb-8"
    @click="scrollToManuals"
  >
    <div
      class="w-14 h-14 flex items-center justify-center rounded-full
             bg-white/20 backdrop-blur-md border border-white/40
             shadow-md hover:bg-green1 transition-all duration-300 relative"
    >
      <!-- Down Arrow -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19 9l-7 7-7-7"
        />
      </svg>

      <!-- Hover Text -->
      <span
        class="absolute -top-10 left-1/2 -translate-x-1/2
               whitespace-nowrap text-white text-md font-light
               opacity-0 group-hover:opacity-100
               transition-opacity duration-300"
      >
        Go to System Manuals
      </span>
    </div>
  </div>
</section>


      <!-- Systems Manual Section -->
<section
  ref="manualSection"
  class="w-full bg-transparent px-4 md:px-8 flex flex-col justify-center items-center min-h-screen"
>
  <!-- Back to Videos Button -->
  <div
    class="cursor-pointer animate-bounce group w-full flex justify-center mt-8 mb-10"
    @click="scrollToVideos"
  >
    <div
      class="w-14 h-14 flex items-center justify-center rounded-full
             bg-white/20 backdrop-blur-md border border-white/40
             shadow-md hover:bg-green1 transition-all duration-300 relative"
    >
      <!-- Up Arrow -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 15l7-7 7 7"
        />
      </svg>

      <span
        class="absolute bottom-16 left-1/2 -translate-x-1/2
               whitespace-nowrap text-white text-md font-light
               opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        Back to Video Tutorials
      </span>
    </div>
  </div>

  <!-- Section Title -->


      <div
        class="flex flex-col items-center text-center w-full max-w-full space-y-3 mb-12"
      >
       
        <h2
          class="text-2xl sm:text-3xl md:text-5xl lg:text-[40px] font-bold text-[#FCF440] text-center leading-tight"
        >
        User Manuals
        </h2>
        <p
          class="text-white text-sm sm:text-base md:text-lg lg:text-[18px] font-light text-center max-w-full sm:max-w-[80%] md:max-w-[70%]"
        >
         Access user manuals and guides for the effective use of DNSC information systems.
        </p>
      </div>

<!-- Manual Cards Carousel -->
<div class="w-full max-w-6xl mx-auto py-10 relative flex items-center">

  <!-- Prev Button -->
  <button
    @click="prevManuals"
    :disabled="manualCarouselIndex === 0"
    :class="[
      'hidden md:block absolute left-0 md:left-[-40px] lg:left-[-120px] px-4 py-2 text-white rounded-full transition-all z-20 group',
      manualCarouselIndex === 0
        ? 'opacity-50 cursor-not-allowed'
        : 'animate-bounce',
    ]"
  >
    <div
      class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>

      <span
        class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        Previous
      </span>
    </div>
  </button>


 <!-- Manual Cards -->
<div
  class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full"
>
  <a
    v-for="manual in paginatedManuals"
    :key="manual.title"
    :href="manual.link"
    target="_blank"
    rel="noopener noreferrer"
    class="group feature-card relative overflow-hidden
           bg-white/10 backdrop-blur-lg
           border border-white/20 rounded-[30px]
           shadow-lg
           hover:shadow-2xl hover:scale-105
           transition-all duration-500"
  >

    <!-- IMAGE AREA -->
    <div class="relative w-full h-[220px] overflow-hidden">

      <!-- System Picture -->
      <img
        :src="manual.img"
        :alt="manual.title"
        class="w-full h-full object-cover
               transition-transform duration-700
               group-hover:scale-110"
      />

      <!-- Dark Gradient Overlay -->
      <div
        class="absolute inset-0
               bg-gradient-to-t
               from-black/80 via-black/20 to-transparent"
      ></div>

      <!-- Manual Icon Overlay -->
      <div
        class="absolute bottom-4 left-5
               w-12 h-12
               rounded-2xl
               bg-white/90
               backdrop-blur-md
               border border-white/50
               shadow-xl
               flex items-center justify-center
               text-green1
               transition-all duration-300
               group-hover:bg-green1
               group-hover:text-white
               group-hover:scale-110"
      >
        <!-- Existing Manual Icon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-8 h-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 6.5
               C10.5 5.2 8.5 4.5 5 4.5
               C4.45 4.5 4 4.95 4 5.5
               V18.5
               C4 19.05 4.45 19.5 5 19.5
               C8.5 19.5 10.5 20.2 12 21
               M12 6.5
               C13.5 5.2 15.5 4.5 19 4.5
               C19.55 4.5 20 4.95 20 5.5
               V18.5
               C20 19.05 19.55 19.5 19 19.5
               C15.5 19.5 13.5 20.2 12 21
               M12 6.5
               V21"
          />
        </svg>
      </div>

    

    </div>

    <!-- CARD CONTENT -->
    <div class="p-5">

      <!-- Title -->
      <h3
        class="text-xl font-bold text-white mb-2
             group-hover:text-green-200
               transition-colors duration-300"
      >
        {{ manual.title }}
      </h3>

      <!-- Description -->
      <p
        class="text-sm text-white/75
               leading-relaxed mb-5"
      >
        {{ manual.description }}
      </p>

      <!-- Open Manual -->
      <div
        class="flex items-center gap-2
               text-sm font-semibold
               text-white
               group-hover:text-green-200
               transition"
      >
        <span>View Manual</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4
                 group-hover:translate-x-1
                 transition-transform"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>

    </div>
  </a>
</div>

  <!-- Next Button -->
  <button
    @click="nextManuals"
    :disabled="
      (manualCarouselIndex + 1) * manualsPerPage >= manuals.length
    "
    :class="[
      'hidden md:block absolute right-0 md:right-[-40px] lg:right-[-120px] px-4 py-2 text-white rounded-full transition-all z-20 group',
      (manualCarouselIndex + 1) * manualsPerPage >= manuals.length
        ? 'opacity-50 cursor-not-allowed'
        : 'animate-bounce',
    ]"
  >
    <div
      class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>

      <span
        class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        Next
      </span>
    </div>
  </button>

</div>
  

  <!-- Scroll to Top / Footer -->
  <div class="cursor-pointer animate-bounce group flex justify-center mt-12">
    <div
      class="w-14 h-14 flex items-center justify-center rounded-full
             bg-white/20 backdrop-blur-md border border-white/40
             shadow-md hover:bg-green1 transition-all duration-300 relative"
      @click="scrollToTop"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-7 w-7 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 15l7-7 7 7"
        />
      </svg>

      <span
        class="absolute top-16 left-1/2 -translate-x-1/2
               whitespace-nowrap text-white text-md font-light
               opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      >
        Back to Top
      </span>
    </div>
  </div>
</section>

      <!-- Footer -->
      <footer
        class="w-full bg-green1/90 backdrop-blur-md border-t border-white/20 text-white flex justify-center items-center px-6 md:px-12 py-4 z-50 mt-20"
      >
        <!-- Left Side -->
        <p class="text-sm md:text-base text-center md:text-left font-light">
          © 2021-{{ currentYear }} Davao del Norte State College | Systems
          Development Unit. All rights reserved.
        </p>
      </footer>
    </div>

    <!-- Back to Top Button -->
    <div
      v-if="showBackToTop"
      class="fixed bottom-8 right-8 z-50 cursor-pointer group"
      @click="scrollToTop"
    >
      <div
        class="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border border-white/40 shadow-md hover:bg-green1 transition-all duration-300 relative"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-7 w-7 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M5 15l7-7 7 7"
          />
        </svg>
        <span
          class="absolute -top-10 left-1/2 -translate-x-1/2 whitespace-nowrap text-white text-md font-light opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          Back to Top
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PMS from "@/assets/img/PMS.png";
import HRIS from "@/assets/img/HRIS.png";
import RMS from "@/assets/img/RMS.png";
import LMS from "@/assets/img/LMS.png";
import AKRED from "@/assets/img/AKRED.png";
import DNSC from "@/assets/img/DNSC.png";
import PIO from "@/assets/img/PIO.png";
import TSSU from "@/assets/img/TSSU.png";
import ISRF from "@/assets/img/ISRF.png";
import HRISCOM from "@/assets/img/HRISCOM.png";
// import RFID from "@/assets/img/RFID.png";
import OSFF from "@/assets/img/OSFF.png";
import IAIMS from "@/assets/img/IAIMS.png";
import AUMS from "@/assets/img/AUMS.png";
import KNOWS from "@/assets/img/KNOWS.png";
import FeedbackCarousel from "./contents/FeedbackCarousel.vue";
import VideoSection from "./contents/VideoSection.vue";
import FRSCOM from "@/assets/img/FRSCOM.png";
import LMSCOM from "@/assets/img/LMSCOM.png";
import RMSCOM from "@/assets/img/RMSCOM.png";
import AKREDCOM from "@/assets/img/AKREDCOM.png";
import KNOWSCOM from "@/assets/img/KNOWSCOM.png";
import HRISMANUAL from "@/assets/img/HRISMANUAL1.png";
import FRSMANUAL from "@/assets/img/FRSMANUAL.png";
import RMSMANUAL from "@/assets/img/RMSMANUAL.png";
import LMSMANUAL from "@/assets/img/LMSMANUAL.png";
import FPSMANUAL from "@/assets/img/FPSMANUAL.png";
import GATEWAYMANUAL from "@/assets/img/GATEWAYMANUAL.png";
import AKREDMANUAL from "@/assets/img/AKREDMANUAL.png";
import AUMSMANUAL from "@/assets/img/AUMSMANUAL.png";

export default {
  name: "GetStarted",
  components: {
    FeedbackCarousel,
    VideoSection,
  },
  data() {
    return {
   manuals: [
  {
    title: "HRIS User Manual",
    description:
      "User guide for navigating and managing employee-related processes in the Human Resource Information System.",
    link: "/pdf/hrismanual.pdf",
    img: HRISMANUAL,
  },

  {
    title: "FRS User Manual",
    description:
      "Guide for managing fund requests, procurement, and other financial processes in the Funds Requisition System (FRS).",
    link: "/pdf/frsmanual.pdf",
    img: FRSMANUAL,
  },

  {
    title: "RMS User Manual",
    description:
      "Step-by-step guide for creating, organizing, managing, and retrieving institutional records.",
    link: "/pdf/rmsmanual.pdf",
    img: RMSMANUAL,
  },

  {
    title: "LMS User Manual",
    description:
      "Guide for using the Learning Management System (LMS), including its main features and user functions.",
    link: "/pdf/lmsmanual.pdf",
    img: LMSMANUAL,
  },

  {
    title: "FPS User Manual",
    description:
      "Guide for using the Faculty Performance Evaluation System (FPS), including evaluation procedures and related features.",
    link: "/pdf/fpsmanual.pdf",
    img: FPSMANUAL,
  },

  {
    title: "Gateway User Manual",
    description:
      "Guide for using the Information Systems Gateway, including accessing available DNSC systems, services, and resources.",
    link: "/pdf/gatewaymanual.pdf",
    img: GATEWAYMANUAL,
  },

  {
    title: "AKRED User Manual",
    description:
      "Guide for using the DNSC Program Accreditation Management Information System (AKRED), including accreditation preparation, evaluation, monitoring, and quality assurance processes.",
    link: "/pdf/akredmanual.pdf",
    img: AKREDMANUAL,
  },

  {
    title: "AUMS User Manual",
    description:
      "Guide for using the Academic Unit Monitoring System (AUMS), including faculty loads, class schedules, and academic monitoring features.",
    link: "/pdf/aumsmanual.pdf",
    img: AUMSMANUAL,
  },
],
      features: [
        {
          description:
            "The Human Resource Information System (HRIS) streamlines employee management by handling employee records, recruitment, attendance, and other HR-related processes on a single, secure platform.",
          img: HRIS,
          link: "https://his.dnsc.edu.ph/login",
          imgLoaded: false,
        },
        {
          description:
            "The Funds, Requisition, and Supply and Inventory System (FRSIS) streamlines fund requests, procurement, and inventory management—ensuring transparency, accuracy, efficiency, and accountability in the utilization of institutional resources.",
          img: PMS,
          link: "https://frs.dnsc.edu.ph/",
          imgLoaded: false,
        },
        {
          description:
            "The Records Management System (RMS) allows users to create, organize, and securely manage institutional records, ensuring efficient documentation and easy retrieval of information.",
          img: RMS,
          link: "https://rms.dnsc.edu.ph/login",
          imgLoaded: false,
        },
        {
          description:
            "The Learning Management System (LMS) and Faculty Performance Evaluation System (FPS) enhance teaching and learning through accessible resources and assessments, and support continuous improvement through faculty evaluation and reporting.",
          img: LMS,
          link: "https://lms.dnsc.edu.ph/login/index.php",
          imgLoaded: false,
        },
        {
          description:
            "The DNSC Knowledge Network and Organizational Wisdom Stream (KNOWS) is a centralized platform for managing, preserving, and sharing institutional knowledge and resources across the University.",
          img: KNOWS,
          link: "https://knows.dnsc.edu.ph/",
          imgLoaded: false,
        },
        {
          description:
            "The DNSC Integrated Academic Information Management System (IAIMS) centralizes and manages academic data and processes, including student records, faculty information, and academic operations—enhancing efficiency, data accuracy, and transparency across institutional academic management.",
          img: IAIMS,
          link: "https://iaims.dnsc.edu.ph/iaims/index.php",
          imgLoaded: false,
        },
        {
          description:
            "The DNSC Academic Unit Monitoring System (AUMS) monitors faculty loads, class schedules, and academic activities to improve efficiency, transparency, and data-driven decision-making.",
          img: AUMS,
          link: "https://aums.dnsc.edu.ph/",
          imgLoaded: false,
        },
        {
          description:
            "The DNSC Program Accreditation Management Information System (AKRED) streamlines accreditation preparation, evaluation, and monitoring—reducing manual work and automating computations to ensure efficiency, accuracy, and transparency in quality assurance.",
          img: AKRED,
          link: "https://mis.dnsc.edu.ph/akred",
          imgLoaded: false,
        },
        {
          description:
            "The Official DNSC Page is the primary online hub for news, announcements, achievements, and public information connecting the DNSC community and stakeholders by promoting transparency, engagement, and awareness of institutional initiatives.",
          img: DNSC,
          link: "https://dnsc.edu.ph/",
          imgLoaded: false,
        },
        {
          description:
            "The PIO Request Management System streamlines information, and publication requests through a centralized platform that tracks, manages approvals, and ensures timely dissemination of official DNSC communications.",
          img: PIO,
          link: "https://dnsc.edu.ph/pres/",
          imgLoaded: false,
        },
        {
          description:
            "The TSSU Support Ticket Form is the official channel for submitting technical concerns and service requests, allowing users to easily report problems and receive timely IT support within the College.",
          img: TSSU,
          link: "https://dnsc.edu.ph/ict-services-request/",
          imgLoaded: false,
        },
        {
          description:
            "The Information Systems Request Form enables formal requisition of data, additional functionalities, and corrective maintenance, ensuring proper documentation, accountability, and coordination with the Systems Development Unit.",
          img: ISRF,
          link: "https://forms.office.com/r/2RK7S0UwmR",
          imgLoaded: false,
        },
        // {
        //   description:
        //     "The RFID Log Data Request Form allows authorized personnel to securely request RFID attendance or access records, ensuring proper documentation, verification, and timely release while upholding data privacy and security standards.",
        //   img: RFID,
        //   link: "https://docs.google.com/forms/d/e/1FAIpQLSeI5j3q1KJ6RsCOW6wNkUSTI04qbsT6cHf4I6qkKpbNqZ8kQQ/viewform?usp=dialog/",
        //   imgLoaded: false,
        // },
        {
          description:
            "The Online System Feedback Form (Beta Testing) lets users share insights and experiences while testing DNSC’s systems, helping the Systems Development Unit gather feedback to fix issues, improve functionality, and ensure efficient deployment.",
          img: OSFF,
          link: "https://docs.google.com/forms/d/e/1FAIpQLSfs9T1zJ32TaNZrgs_M_mWtMfYHk4FmDzpJmUBVTCakhP5Tvw/viewform?pli=1&pli=1/",
          imgLoaded: false,
        },
         {
          description:
            "The HRIS User Community connects DNSC HRIS users to share experiences, ask questions, provide feedback, report issues, and stay updated on HRIS announcements and improvements.",
          img: HRISCOM,
          link: "https://www.facebook.com/share/g/1Dpp4QHVZC/",
          imgLoaded: false,
        },
           {
          description:
            "The FRS & SIS User Community connects DNSC FRS & SIS users to share experiences, ask questions, provide feedback, report issues, and stay updated on FRS & SIS announcements and improvements.",
          img: FRSCOM,
          link: "https://www.facebook.com/share/g/14t8M8dT71h/",
          imgLoaded: false,
        },
          {
          description:
            "The LMS & FPS User Community connects DNSC LMS & FPS users to share experiences, ask questions, provide feedback, report issues, and stay updated on LMS & FPS announcements and improvements.",
          img: LMSCOM,
          link: "https://www.facebook.com/share/g/1HvCYXJNGw/",
          imgLoaded: false,
        },
         {
          description:
            "The KNOWS User Community connects DNSC KNOWS users to share experiences, ask questions, provide feedback, report issues, and stay updated on KNOWS announcements and improvements.",
          img: KNOWSCOM,
          link: "https://www.facebook.com/share/g/19Ruox47zL/",
          imgLoaded: false,
        },
         {
          description:
            "The RMS User Community connects DNSC RMS users to share experiences, ask questions, provide feedback, report issues, and stay updated on RMS announcements and improvements.",
          img: RMSCOM,
          link: "https://www.facebook.com/share/g/1XCLh3MX6P/",
          imgLoaded: false,
        },
          {
          description:
            "The AKRED User Community connects DNSC AKRED users to share experiences, ask questions, provide feedback, report issues, and stay updated on AKRED announcements and improvements.",
          img: AKREDCOM,
          link: "https://www.facebook.com/share/g/1JHnMtiYzv/",
          imgLoaded: false,
        },
      ],
      showBackToTop: false,

      // Carousel
      carouselIndex: 0,
      cardsPerPage: 6,

      // Manuals Carousel
manualCarouselIndex: 0,
manualsPerPage: 6,


      cardObserver: null,
      currentYear: new Date().getFullYear(),
      // ---- New Feedback Carousel ----
    };
  },
  computed: {
    visibleFeedbacks() {
      const total = this.feedbacks.length;
      return [
        this.feedbacks[(this.feedbackIndex + total - 1) % total],
        this.feedbacks[this.feedbackIndex],
        this.feedbacks[(this.feedbackIndex + 1) % total],
      ];
    },
    paginatedFeatures() {
      const start = this.carouselIndex * this.cardsPerPage;
      return this.features.slice(start, start + this.cardsPerPage);
    },

    paginatedManuals() {
  const start = this.manualCarouselIndex * this.manualsPerPage;
  return this.manuals.slice(start, start + this.manualsPerPage);
},
  },
  methods: {
  nextManuals() {
  if (
    (this.manualCarouselIndex + 1) * this.manualsPerPage <
    this.manuals.length
  ) {
    this.manualCarouselIndex++;
  }
},

prevManuals() {
  if (this.manualCarouselIndex > 0) {
    this.manualCarouselIndex--;
  }
},
    nextCards() {
      if ((this.carouselIndex + 1) * this.cardsPerPage < this.features.length) {
        this.carouselIndex++;
      }
    },
    prevCards() {
      if (this.carouselIndex > 0) {
        this.carouselIndex--;
      }
    },
    toggleVideo(refName) {
      const video = this.$refs[refName];
      if (!video) return;
      if (video.paused) {
        video.muted = false;
        video.play();
        this.videoStatus[refName] = true;
      } else {
        video.pause();
        this.videoStatus[refName] = false;
      }
    },
    toggleFullscreen(refName) {
      const video = this.$refs[refName];
      if (!video) return;
      if (!document.fullscreenElement) {
        video.requestFullscreen();
        this.fullscreen[refName] = true;
      } else {
        document.exitFullscreen();
        this.fullscreen[refName] = false;
      }
    },scrollToManuals() {
  this.$refs.manualSection.scrollIntoView({ behavior: "smooth" });
},
    scrollToDashboard() {
      this.$refs.dashboardSection.scrollIntoView({ behavior: "smooth" });
    },
    scrollToCards() {
      this.$refs.cardsSection.scrollIntoView({ behavior: "smooth" });
    },
    scrollToVideos() {
      this.$refs.videoSection.scrollIntoView({ behavior: "smooth" });
    },
    scrollToTestimonies() {
      this.$refs.testimoniesSection.scrollIntoView({ behavior: "smooth" });
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
    updateCardsPerPage() {
      if (window.innerWidth < 768) {
        this.cardsPerPage = this.features.length;
      } else {
        this.cardsPerPage = 6;
      }
      this.setupObserver();
    },
    setupObserver() {
      this.features.forEach((f) => {
        if (typeof f.visible === "undefined") f.visible = false;
      });
      if (this.cardObserver) {
        this.cardObserver.disconnect();
      }
      this.cardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const idxAttr = entry.target.getAttribute("data-index");
            if (idxAttr === null) return;
            const idx = parseInt(idxAttr, 10);
            if (Number.isNaN(idx)) return;
            if (entry.isIntersecting) {
              this.features[idx].visible = true;
            }
          });
        },
        { threshold: 0.2 },
      );
      this.$nextTick(() => {
        const cards = this.$el.querySelectorAll(".feature-card");
        cards.forEach((card) => {
          const idxAttr = card.getAttribute("data-index");
          if (idxAttr !== null) {
            const idx = parseInt(idxAttr, 10);
            if (!Number.isNaN(idx) && this.features[idx]) {
              this.features[idx].visible = this.features[idx].visible || false;
            }
          }
          this.cardObserver.observe(card);
        });
      });
    },
  },
  watch: {
    carouselIndex() {
      const start = this.carouselIndex * this.cardsPerPage;
      const end = Math.min(start + this.cardsPerPage, this.features.length);
      for (let i = start; i < end; i++) {
        this.features[i].visible = false;
      }
      this.setupObserver();
    },
    cardsPerPage() {
      this.setupObserver();
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.updateCardsPerPage();
    window.addEventListener("resize", this.updateCardsPerPage);
    this.features.forEach((f) => (f.visible = false));
    this.setupObserver();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateCardsPerPage);
    if (this.cardObserver) this.cardObserver.disconnect();
  },
};
</script>

<style scoped>

@keyframes spinSlow {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.animate-spinSlow {
  animation: spinSlow 20s linear infinite;
}
.pgs-btn {
  transition: all 0.3s ease;
}
.pgs-btn:hover {
  transform: translateY(-2px);
}
.pgs-div2 {
  overflow: visible;
}
section.cards-section {
  min-height: 100vh;
  overflow-y: auto;
}
/* small tweak to make the transition on opacity+translate smooth in case Tailwind build differs */
.feature-card {
  will-change: transform, opacity;
}
@keyframes shimmer {
  0% {
    background-position: -400px 0;
  }
  100% {
    background-position: 400px 0;
  }
}

.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.15) 25%,
    rgba(255, 255, 255, 0.35) 37%,
    rgba(255, 255, 255, 0.15) 63%
  );
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;
}
</style>
